import { createContext, useContext } from "react"
import { UrlParams } from "./url/params/UrlParams"

type AppContextValue = {
  urlParams: UrlParams
}

export const AppContext = createContext<AppContextValue | undefined>(undefined)

export const useAppContext = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error("useAppContext must be used within an AppContext.Provider")
  }
  return context
}
